import { formatDate } from '@shared/services/dateService';
import CheckpointDocumentsMapper from './checkPointDocumentsMapper';
import PerformanceItemsMapper from './performanceItemsMapper';
import { MDDAP_CHECK_POINTDOCUMENT_TYPES } from '../../constants/mddap-checkpoint-document-types';

const CheckPointMapper = {
  checkPointToCacheData: (checkPoint, selectedAppraisalId, orgUnitId, pageMode) => ({
    dataCollectionDate: checkPoint.DataCollectionDate
      ? new Date(checkPoint.DataCollectionDate)
      : null,
    dataCollectedDuringAppraisal: checkPoint.DataCollectedDuringAppraisal,
    checkPointDocuments: checkPoint.CheckpointDocuments.map(CheckpointDocumentsMapper.toTableData),
    performanceMetrics: checkPoint.CheckpointPerformanceItems.map((metric, index) => ({
      ...PerformanceItemsMapper.performanceMetricToTableData(metric, pageMode),
      tempId: index
    })),
    appraisalId: selectedAppraisalId,
    orgUnitId: orgUnitId,
    checkPointId: checkPoint.Id,
    isDraft: checkPoint.IsDraft,
    selectedPerformanceMetric: null,
    hasReappraisalRationaleBeforeEditing:
      !checkPoint.IsDraft &&
      checkPoint.CheckpointDocuments.some(
        x => x.DocumentType === MDDAP_CHECK_POINTDOCUMENT_TYPES.ReappraisalRationale
      )
  }),
  checkPointToApolloInput: (checkPoint, checkPointId) => ({
    CheckPointId: checkPointId,
    DataCollectionDate: checkPoint.dataCollectionDate
      ? formatDate(checkPoint.dataCollectionDate)
      : null,
    DataCollectedDuringAppraisal: checkPoint.dataCollectedDuringAppraisal,
    UploadedFiles: checkPoint.checkPointDocuments.map(
      CheckpointDocumentsMapper.documentToApolloInput
    ),
    PerformanceReportMetrics: checkPoint.performanceMetrics.map(
      PerformanceItemsMapper.performanceMetricToApolloInput
    )
  })
};

export default CheckPointMapper;
